module.exports = __webpack_public_path__ + "img/back.91df4224.png";